import { StyleSheet, Text, View } from '@react-pdf/renderer';
import type { CdaSection } from '../../parsers/types';
import { styles as headingStyles } from './pdf-heading-renderer';
import { PdfHtmlRenderer } from './pdf-html-renderer';

const styles = StyleSheet.create({
  section: {
    fontWeight: 400,
    fontFamily: 'Inter',
    flexDirection: 'column',
    gap: 10,
  },
});

interface PdfSectionRendererProps {
  section: CdaSection;
}

export const PdfSectionRenderer = ({ section }: PdfSectionRendererProps) => {
  return section.id && section.title ? (
    <View style={styles.section} id={`section-${section.id}-${section.index}`} wrap={false}>
      <Text style={[headingStyles.h2, { marginBottom: 4 }]}>
        {section.index + 1}. {section.title}
      </Text>
      {section.html && <PdfHtmlRenderer section={section} html={section.html} />}
    </View>
  ) : null;
};
